import React, { useContext, useEffect, useState, useRef } from 'react';
import './filtersearch.css';
import { addcontext } from '../ContextShare/ContextShare';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { FilterSearch, GetAllMemberIdArray, GetAllMemberIdArrayWithSession, GetEventListForSearchFilter, GetInitialDate, GetKlaListForSearchFilter, GetMemberListForRulingsFilterWithSession, GetMemberListForSearchFilter, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla } from '../Services/allApi';
import { toast } from 'react-toastify';
import language from '../language.json'

function FilterSearchCommon() {
  const [searchFilterData, setsearchFilterData] = useState({
    kla_id: '', session_id: '', member_id: '', event_id: '', start_date: '', end_date: ''
  });
  const {isSearchOrAdSearch,setIsSearchOrAdSearch}=useContext(addcontext)

  const {paginationStartIndex,setPaginationStartIndex}=useContext(addcontext)
    const {paginationEndIndex,setPaginationEndIndex}=useContext(addcontext)
  const {searchError,setSearchError}=useContext(addcontext)
  const{totalSearchResults,seTtotalSearchResults}=useContext(addcontext)
  const { InitialSearchQuery, setInitialSearchQuery } = useContext(addcontext);
  const [klaList, setKlaList] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [initailStartDate, setInitailStartDate] = useState();
  const [initailEndDate, setInitailEndDate] = useState();
  const [selectedOptionKla, setSelectedOptionKla] = useState(null);
  const [selectedOptionSession, setSelectedOptionSession] = useState(null);
  const [selectedOptionEvents, setselectedOptionEvents] = useState(null);
  const [selectedOptionMember, setselectedOptionMember] = useState(null);
  const { filterSearchResults, setFilterSearchResults } = useContext(addcontext);
  const [searchValue, setSearchValue] = useState('');
  const [selectedEvent, setSelectedEvent] = useState('');
  const [selectedSession, setSelectedSession] = useState('');
  const [selectedKLA, setSelectedKLA] = useState('');
  const [selectedMember, setSelectedMember] = useState('');
  const [selectedFromDate, setselectedFromDate] = useState('');
  const [selectedToDate, setselectedToDate] = useState('');
  const [filterData, setFilterData] = useState({ sessionvalue: '', klavalue: '', eventvalue: '', membervalue: '' });
  const [buttonClickedLoding,setButtonClickedLoding]=useState(false)

  const navigate = useNavigate();

  const { isFilterOpenC, setFilterOpenC } = useContext(addcontext);
  const ref = useRef();

  const {langChanged,setlangChanged}=useContext(addcontext)

  const [currentLanguage, setCurrentLanguage] = useState();

  useEffect(()=>{
      setCurrentLanguage(localStorage.getItem('language')||'en')

},[currentLanguage,langChanged])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setFilterOpenC(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setFilterOpenC]);

  // get kla list
  const klaListCallApi = async () => {
    try {
      const result = await GetKlaListForSearchFilter();
      setKlaList(result?.data?.data);
    } catch (error) {
      console.error("Error fetching Kla list for filter:", error);
    }
  };

  useEffect(() => {
    klaListCallApi();
  }, []);

  const klaoptions = klaList?.map((item) => ({
    value: item.kla_no,
    label: `${language.kla[currentLanguage]}${item.kla_no}`,
    valuefrosearch: item.kla_id
  }));

  // get session list
  const SessionListCallApi = async () => {
    try {
      const resultSession = selectedOptionKla ? 
        await GetSessionListForSearchFilterWithKla(selectedOptionKla.valuefrosearch) :
        await GetSessionListForSearchFilter();
      setSessionList(resultSession?.data?.data);
    } catch (error) {
      console.error("Error fetching Session list for filter:", error);
    }
  };

  useEffect(() => {
    SessionListCallApi();
  }, [selectedOptionKla]);

  const sessionoptions = sessionList?.map((item) => ({
    value: item.session_no,
    label: `${language.Session[currentLanguage]}${item.session_no}`,
    valuefrosearch: item.session_id
  }));

  // get event list
  const EventListCallApi = async () => {
    try {
      const resultEvent = await GetEventListForSearchFilter();
      setEventList(resultEvent?.data?.data);
    } catch (error) {
      console.error("Error fetching Event list for filter:", error);
    }
  };

  useEffect(() => {
    EventListCallApi();
  }, []);

  const eventoptions = eventList?.map((item) => ({
    value: item.event_name,
    label: currentLanguage=='en'?item?.event_name:item?.mal_event_name,
    valuefrosearch: item.event_id
  }));

  // get Member list
  const MemberListCallApi = async () => {
    try {
      const resultMember = selectedOptionSession ? 
        await GetAllMemberIdArrayWithSession({ session_id: selectedOptionSession?.valuefrosearch }) :
        await GetAllMemberIdArray();
      setMemberList(resultMember?.data);
    } catch (error) {
      console.error("Error fetching Member list for filter:", error);
    }
  };

  useEffect(() => {
    MemberListCallApi();
  }, [selectedOptionSession?.value]);

  const memberoptions = memberList?.map((item) => ({
    value: item.member,
    label: currentLanguage=='en'?item.member:item?.malayalam_member_name,
    valuefrosearch: item.id
  }));

  // get date when session selected
  const getinitialdateapi = async () => {
    try {
      if (selectedOptionSession != null) {
        const resultdate = await GetInitialDate(selectedOptionSession.valuefrosearch);
        // setselectedFromDate(resultdate.data[0].session_start_date);
        // setselectedToDate(resultdate.data[0].session_end_date);
      }
    } catch (error) {
      console.error("Error fetching date list for filter:", error);
    }
  };

  useEffect(() => {
    getinitialdateapi();
  }, [selectedOptionSession]);

  const handlechange = (selectedOptionKla) => {
    setSelectedOptionKla(selectedOptionKla);
    setSelectedOptionSession(null);
    setselectedOptionMember(null);
  };

  const handlechangesession = (selectedOptionSession) => {
    setSelectedOptionSession(selectedOptionSession);
    setselectedOptionMember(null);
  };

  const handlechangeevents = (selectedOptionEvents) => {
    setselectedOptionEvents(selectedOptionEvents);
  };

  const handlechangemembers = (selectedOptionMember) => {
    setselectedOptionMember(selectedOptionMember);
  };

  const handleSearchButtonClick = (e) => {
    try {
      e.preventDefault();
      const searchData = {
        kla_id: selectedOptionKla?.valuefrosearch,
        session_id: selectedOptionSession?.valuefrosearch,
        member_id: selectedOptionMember?.valuefrosearch,
        event_id: selectedOptionEvents?.valuefrosearch,
        start_date: selectedFromDate !== "" && selectedFromDate !== null ? selectedFromDate : undefined,
        end_date: selectedToDate !=="" && selectedToDate !== null ? selectedToDate : undefined,
      };

      if(searchData.kla_id||searchData.session_id||searchData.member_id||searchData.event_id||searchData.start_date||searchData.end_date){
        console.log(searchData);
        setButtonClickedLoding(true)

        searchsubmitapi(searchData)}
        else{
          toast.warning("Please select an option to search")
        }
    } catch {
      alert("Not found");
    }
  };

  const searchsubmitapi = async (searchData) => {
    try {
      const resultSearch = await FilterSearch(searchData, 1, 10);
      setInitialSearchQuery(searchData);

        setFilterSearchResults(resultSearch.data?.data);
        setSearchError(resultSearch?.response?.data?.message)
        seTtotalSearchResults(resultSearch?.data?.count)

        setIsSearchOrAdSearch('as')
        setPaginationStartIndex(1)
        setPaginationEndIndex(10)
      navigate('/results');
      setFilterOpenC(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div ref={ref} className='flex w-full h-full justify-center bg-success lg:w-3/6 md:w-5/6  text-white border-2 mt-4' style={{borderRadius: '10px'}}>
      <div className='flex flex-col  w-full p-4' style={{  height: '100%' }}>
        {/* select KLA */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_kla[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
            placeholder={language.Select_option[currentLanguage]}
              className='w-full'
              options={klaoptions}
              value={selectedOptionKla}
              onChange={handlechange}
            />
          </div>
        </div>

        {/* select session */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_session[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
            placeholder={language.Select_option[currentLanguage]}
              className='w-full'
              options={sessionoptions}
              value={selectedOptionSession}
              onChange={handlechangesession}
            />
          </div>
        </div>

        {/* select Events */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_event[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
            placeholder={language.Select_option[currentLanguage]}
              className='w-full'
              options={eventoptions}
              value={selectedOptionEvents}
              onChange={handlechangeevents}
            />
          </div>
        </div>

        {/* select Members */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_members[currentLanguage]}</h3></div>
          <div className='flex w-7/12'>
            <Select
            placeholder={language.Select_option[currentLanguage]}
              className='w-full'
              options={memberoptions}
              value={selectedOptionMember}
              onChange={handlechangemembers}
            />
          </div>
        </div>

        {/* select Date */}
        <div className='flex flex-row mt-10 w-full justify-between text-black'>
          <div className='w-4/12'><h3>{language.Select_date[currentLanguage]}</h3></div>
          <div className='flex flex-col md:flex-row w-7/12'>
            <div className='flex flex-col md:w-6/12 w-full'>
              <label htmlFor="fromdate">{language.From[currentLanguage]}</label>
              <input id='fromdate' value={selectedFromDate} onChange={(e) => setselectedFromDate(e.target.value)} type="date" placeholder='Date from' className='w-full rounded h-10' style={{ border: '1px solid silver' }} />
            </div>
            <div className='flex flex-col md:w-6/12 w-full mt-4 md:mt-0'>
              <label htmlFor="todate">{language.To[currentLanguage]}</label>
              <input type="date" id='todate' value={selectedToDate} onChange={(e) => setselectedToDate(e.target.value)} placeholder='Date to' className='w-full rounded h-10' style={{ border: '1px solid silver' }} />
            </div>
          </div>
        </div>

        {/* search button */}
        <div className='flex flex-row justify-center sm:mt-12 mt-8 mb-8 text-white w-full'>
          {!buttonClickedLoding?<button className='w-1/3 h-10 me-2 hover:scale-105' style={{ borderRadius: '44px', backgroundColor: '#001F33' }} onClick={handleSearchButtonClick}>{language.Search[currentLanguage]}</button>
          :
          <button className='flex flex-row justify-center items-center gap-2 w-1/3 h-10 me-2 bg-white border border-blue-500' style={{ borderRadius: '44px'}}
          ><div className="loader"></div><span className='text-blue-900'>Loading...</span></button>
        }
          <button className='w-1/3 h-10 ms-2 hover:scale-105 bg-gray-200 border-blue-500 hover:bg-gray-500 hover:text-white transform duration-500 ease-in-out border text-black hover:border-none' style={{ borderRadius: '44px' }} onClick={() => setFilterOpenC(false)}>{language.close[currentLanguage]}</button>
         
        </div>
      </div>
    </div>
  );
}

export default FilterSearchCommon;
